export default () => Math.random().toString().replace(/0|\./g, '').substr(0, 8);